<mat-dialog-content class="basic-info-dialog-content" [ngClass]="{ 'with-title': data?.title || data?.subTitle }">
  <div class="header-section mat-header-row">
    <mat-icon *ngIf="data?.icon">{{ data.icon }}</mat-icon>
    <h1 [ngClass]="{ rtl: rightToLeftSite }" *ngIf="data?.title">{{ data.title }}</h1>
    <h2 [ngClass]="{ rtl: rightToLeftSite }" *ngIf="data?.subTitle">{{ data.subTitle }}</h2>
  </div>
  <div
    *ngIf="data?.body"
    class="modal-body mb-0"
    [ngClass]="{ rtl: rightToLeftSite }"
    [innerHtml]="data?.body"
    tabindex="0"
  ></div>
  <div *ngIf="data?.closeBtn" class="button-container">
    <button aria-label="close" [color]="data?.buttonType" mat-raised-button mat-dialog-close>
      {{ 'RequestDialogComponent:Close' | translate }}
    </button>
  </div>
</mat-dialog-content>

<button class="basic-info-dialog-close-button" mat-icon-button tabindex="0" aria-label="close" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
